export default {
  affiliate: {
    // Main navigation
    title: 'Afiliasi',
    cantFindQuestion: 'Tidak dapat menemukan pertanyaan?',
    onlineService: 'Layanan Online',
    dashboard: 'Dasbor',
    myRewards: 'Hadiah Saya',
    // My Price 页（照 Figma 重做）
    team: 'Team',
    myPrice: 'My Price',
    rule: 'Rule',
    checkOutRules: 'Check Out Our Rules',
    rewardsOverview: 'Rewards Overview',
    rewardAmount: 'Reward Amount',
    date: 'Date',
    selectDate: 'Select Date',
    commissionRewards: 'Commission Rewards',
    noReferralRewards: 'No referral rewards yet \nInvite friends to start earning rewards',
    noCommissionRewards: 'No commission rewards yet \nStart earning by inviting friends',
    inviteFriendsToEarnTitle: 'Invite Friends To Earn',
    moreFriendsMoreRewards: 'More friends, more rewards, unlimited earning potential !',
    inviteNow: 'Invite Now',
    invitationRewards: 'Hadiah Undangan',
    rules: 'Aturan',

    // Team Info
    teamData: 'Data Tim',
    details: 'Detail',
    totalValidFriends: 'Total teman valid:',
    todayTotalWager: 'Total taruhan hari ini:',
    rewards: 'Hadiah',

    // Commission rates
    inviteFriendsCommissionUpTo: 'Komisi Undang Teman Hingga',
    expandTeamBonus: 'Bonus Ekspansi Tim',
    maxLevelCommission: 'Komisi Level Maksimal',
    inviteFriendsCommission: 'Komisi Undang Teman',
    maxPerformanceCommission: 'Komisi Performa Maksimal',
    unlimitedAgent: 'Agen Tak Terbatas',
    unlimitedCommission: 'Komisi Tak Terbatas',
    commissionRate: 'Tingkat Komisi',

    // Team Invite Friends
    inviteFriendsToEarn: 'UNDANG TEMAN UNTUK MENDAPATKAN',
    link: 'Tautan',
    code: 'Kode',
    inviteFriends: 'Undang teman',
    share: 'Bagikan',

    // Withdrawal Rewards
    totalCommission: 'Total Commission',
    claim: 'Klaim',
    bettingBonus: 'Betting Bonus',
    depositBonus: 'Deposit Bonus',
    todayReceived: 'Diterima Hari Ini',

    // Live Rewards
    liveRewards: 'Hadiah Langsung',
    sendTotalCommission: 'Kirim total komisi',

    // Team Data Details
    totalRewardsReceived: 'Total Commission',
    todayInviteFriends: 'Undang Teman Hari Ini',
    todayDepositFriends: 'Teman Deposit Hari Ini',
    depositFriends: 'Teman Deposit',
    validFriends: 'Teman Valid',

    // Dialogs
    howMakeFriendsSubordinates: 'Cara menjadikan teman sebagai bawahan Anda:',
    shareInvitationLink: 'Bagikan tautan undangan Anda agar mereka mendaftar.',
    shareInvitationCode: 'Bagikan kode undangan Anda agar mereka masukkan saat pendaftaran.',
    shareQRCode: 'Bagikan kode QR Anda agar mereka pindai dan daftar.',
    depositFriendsDescription: 'Ketika teman bawahan Anda berhasil menyetor uang, mereka akan menjadi teman yang menyetor.',
    howMakeFriendsValidUsers: 'Cara menjadikan teman Anda pengguna valid:',
    successfullyInviteFriends: 'Berhasil mengundang teman untuk mendaftar.',
    cumulativeDepositsReach: 'Setoran kumulatif mereka mencapai 10.00 USDT.',
    cumulativeValidBetsReach: 'Taruhan valid kumulatif mereka mencapai 50.00 USDT.',
    thenBecomeValidUsers: 'Kemudian, mereka akan menjadi pengguna valid.',

    // Share Dialog
    shareTitle: 'Bagikan',
    player: 'Pemain',
    saveImage: 'Simpan gambar',
    saveImageSuccess: "Gambar disimpan",
    saveImageFailed: "Gagal menyimpan, coba lagi",
    copy: 'Salin',
    copied: 'Disalin!',

    // Received/Withdraw
    received: 'Diterima',
    withdraw: 'Tarik',
    history: 'Riwayat',
    referralRewards: 'Hadiah Rujukan',
    commission: 'Komisi',
    depositRebate: 'Rabat Deposit',
    levelUpRewards: 'Hadiah Naik Level',
    loading: 'Memuat...',
    noMoreRecords: 'Tidak ada catatan lagi',
    loadMore: 'Muat lebih banyak',
    pending: 'Tertunda',
    paid: 'Dibayar',
    rejected: 'Ditolak',
    unknown: 'Tidak Diketahui',
    upgradeReward: 'Hadiah Naik Level',
    cancelled: 'Dibatalkan',
    receiving: 'Sedang Diterima',
    failed: 'Gagal',
    expired: 'Kedaluwarsa',

    // History Dialog
    pickDate: 'Pilih tanggal',
    select: 'Pilih',
    chooseBonus: 'Pilih bonus',
    all: 'Semua',

    // Invitation Rewards Page
    inviteFriendToGet: 'Undang teman untuk mendapatkan',
    yourFriendGet: 'Teman Anda mendapat',
    inviteFriendsEarnRewards: 'Undang teman dan dapatkan hadiah',
    dailyInvitations: 'Undangan harian',

    // Rules - How to earn
    howToEarnAffiliateRewards: 'Cara mendapatkan hadiah afiliasi?',
    shareToFriends: 'Bagikan ke teman',
    shareReferralLink: 'Bagikan tautan rujukan, kode, atau kode QR Anda dengan teman-teman Anda',
    friendsSignUpDeposit: 'Teman mendaftar dan menyetor',
    inviteFriendsRegisterDeposit: 'Undang teman untuk mendaftar di AFUN dan melakukan setoran pertama.',
    getUpTo: 'Dapatkan hingga',
    earnBigRewards: 'Dapatkan hadiah & komisi saat teman bertaruh, menyetor, dan mencapai VIP.',
    noticeEnsureCorrect: 'Pemberitahuan: Pastikan tautan undangan, kode QR, atau kode sudah benar.',

    // Rules - Commission Work
    howCommissionWork: 'Bagaimana cara kerja Komisi?',
    agentRatingDescription: 'Deskripsi Peringkat Agen',
    you: 'ANDA',
    commissionDescription: 'Dapatkan komisi dari deposit dan taruhan Teman B, C, D, dan seterusnya. Lihat tabel di kanan untuk tarif komisi.',
    claimConditions: 'Kondisi klaim',
    teamLevel: 'Level Tim',
    earnUpTo: "Earn up to",
    expandYourTeam: "Perluas Tim Anda",
    earnAnExtra: "Dapatkan Ekstra",
    upgradeAgentLevel: "Tingkatkan Level Agen Anda",
    todayValidFriends: "Today valid friends",
    inviteFriendsAndEarn: "INVITE FRIENDS AND EARN",
    joinUsGetCommission: "Join us and get more commission",
    shareLinkInviteDesc: "Share the link with your friends and invite them to register and deposit, you and your friend can get shared commissions.",
    totalSize: 'Ukuran Total',
    teamWager: 'Taruhan Tim',
    rebateRewardVary: 'Hadiah Rabat & Hadiah Isi Ulang bervariasi berdasarkan level Tim Anda pada hari itu.',
    teamSizeDescription: 'Ukuran tim: Jumlah pengguna valid yang Anda miliki saat ini.',
    teamBettingDescription: 'Taruhan tim: Jumlah total taruhan yang dibuat bawahan Anda dalam satu hari.',
    teamCommissionTitle: 'TEAM COMMISSION\n\nEarn from every deposit and every bet across your network.',
    teamCommissionMainTitle: 'KOMISI TIM',
    teamCommissionSubTitle: 'Dapatkan dari setiap deposit dan\nsetiap taruhan di jaringan Anda.',
    friendsBettingRebate: 'Friends betting rebate commission',
    commissionCalcEvery24h: 'The system calculates commissions every 24 hours.',
    earnCommissionWhenBet: 'You earn a commission when your friends or their friends place bets.',
    commissionSameIpRule: 'Commissions cannot be released to accounts that share the same IP address, device, or shared account, regardless of whether they are on public networks (such as schools, libraries, and offices) or private networks (such as homes and apartments). To receive commissions, the referred account must be on a unique IP address, not shared with other accounts on the platform.',
    commissionFormula: 'Commission = total team wager * 1% * commission rate.',
    commissionRangeDescription: 'You can receive a certain percentage of commission from all the wager and recharge amount made by A, B, C, D, E and F. Please refer to the following diagram for specific commission rates.',
    commissionSupportGames: 'Commission Support Games',

    // Rules - Invitation Rewards
    inviteFriendsBothReceive: 'Undang teman, dan keduanya akan menerima hadiah',
    inviteRegisterReceive: 'Berhasil mengundang teman untuk mendaftar dan menerima',
    friendDepositWagerUnlock: 'Ketika teman Anda menyetor 10.00 USDT dan bertaruh 50.00 USDT, Anda membuka hadiah 3.00 USDT, dan teman Anda mendapat 2.00 USDT.',

    // Team Data Dialog / Rewards 补充
    recentInviteFriends: 'Undangan Teman Terbaru',
    recentDepositFriends: 'Teman Deposit Terbaru',
    today: 'Hari Ini',
    yesterday: 'Kemarin',
    thisMonth: 'Bulan ini',
    friendsData: 'Data Teman',
    joinDate: 'Tanggal Bergabung',
    search: 'Cari',
    level: 'Level',
    tier: 'Tingkat',
    affiliateTreasureBox: 'Kotak Harta Afiliasi',
    referralRewardsDesc: 'Ketika Anda mengundang teman untuk mendaftar, Anda dan teman Anda akan menerima bonus besar.',
    commissionDesc: 'Anda dan tim Anda bekerja sama untuk mencapai tujuan dan mendapatkan komisi besar.',
    affiliateTreasureBoxDesc: 'Undang teman untuk mendapatkan bonus pencapaian',
  }
};
